module.exports = __webpack_public_path__ + "img/VN.44c0954e.svg";